import { Directive, EventEmitter, InjectionToken, Input, OnChanges } from '@angular/core';

export const FI_TOGGLE_VISIBILITY_STATUS_CHANGE = new InjectionToken<EventEmitter<boolean>>(
    'FI_TOGGLE_VISIBILITY_STATUS_CHANGE',
);

@Directive({
    selector: '[fiToggleVisibility]',
    providers: [
        {
            provide: FI_TOGGLE_VISIBILITY_STATUS_CHANGE,
            useFactory: (d: FiToggleVisibilityDirective) => d.toggleVisibilityChange,
            deps: [FiToggleVisibilityDirective],
        },
    ],
    standalone: false,
})
export class FiToggleVisibilityDirective implements OnChanges {
    @Input() fiToggleVisibility: boolean;

    toggleVisibilityChange = new EventEmitter<boolean>();

    ngOnChanges(changes) {
        if (changes.fiToggleVisibility) {
            this.toggleVisibilityChange.emit(this.fiToggleVisibility);
        }
    }
}
